import React from "react";
import { ChamberLabel } from "@logora/parliament.parliament_chamber.chamber_label";
import { Box } from "@logora/parliament.ui.box";
import { Box as MuiBox } from "@mui/material";
import { Label } from "@logora/parliament.ui.label";
import { Show } from "../components/show/Show";
import { AlertButton } from "../alerts";
import { useRedirect } from "react-admin";
import { formatDate, sanitize, formatActeur } from "../formatters";
import { formatCodeCloture, formatType } from "../datasets/questions";
import styles from "./QuestionShow.module.scss";

const QuestionDetails = ({ resource }) => {
	const redirectTo = useRedirect();
	return (
		<>
			<div className={styles.header}>
				<ChamberLabel chamber={resource.chambre} />
				<Label text={formatType(resource)} />
				<MuiBox className={styles.alertButton}>
					<AlertButton targetClass={"Question"} targetId={resource.uid} />
				</MuiBox>
			</div>
			<div className={styles.title}>{resource.titre}</div>
			<div className={styles.presentation}>
				<div className={styles.box}>
					<Box title="Auteur" className={styles.boxContainer}>
						{formatActeur(resource.acteurRef, "small")}
					</Box>
				</div>
				<div className={styles.box}>
					<Box title="Ministère intérrogé" className={styles.boxContainer}>
						<div
							className={styles.link}
							onClick={() =>
								redirectTo(`/parliament/organes/${resource.minIntRefUid}`)
							}
						>
							<div>{resource.minIntRef?.libelleAbrege}</div>
						</div>
					</Box>
				</div>
				<div className={styles.box}>
					<Box title="Date de dépôt" className={styles.boxContainer}>
						<div>{formatDate(resource.dateDepot)}</div>
					</Box>
				</div>
				<div className={styles.box}>
					<Box title="Statut" className={styles.boxContainer}>
						<div>{formatCodeCloture(resource)}</div>
					</Box>
				</div>
			</div>
			<div className={styles.corps}>
				{resource.type !== "QG" && (
					<div className={styles.box}>
						<Box title="Question" className={styles.boxContainer}>
							<div>{resource.texteQuestion}</div>
						</Box>
					</div>
				)}
				<div className={styles.box}>
					<Box
						title={resource.type === "QG" ? "Question et réponse" : "Réponse"}
						className={styles.boxContainer}
					>
						{resource.texteReponse ? (
							<div dangerouslySetInnerHTML={sanitize(resource.texteReponse)} />
						) : (
							<i>Pas de réponse pour l'instant</i>
						)}
					</Box>
				</div>
			</div>
		</>
	);
};

export const QuestionShow = () => {
	return (
		<Show
			resource={"questions"}
			includes={["acteurRef.groupeParlementaire", "acteurRef.mandatPrincipal", "minIntRef"]}
		>
			<QuestionDetails />
		</Show>
	);
};
